import React, {useCallback} from 'react'
import {Editor} from '@tiptap/react'
import {
  DEFAULT_FONT_SIZE,
  DEFAULT_BUTTON_COLOR,
  DEFAULT_BUTTON_BACKGROUND_COLOR,
  DEFAULT_BUTTON_ALIGNMENT,
  DEFAULT_BUTTON_TEXT,
} from './extensions/CustomButton'

type CustomButtonToolbarProps = {
  editor: Editor
}

export default function CustomButtonToolbar({
  editor,
}: CustomButtonToolbarProps) {
  const update = useCallback(
    (newAttrs: Record<string, any>) => {
      editor.chain().updateCustomButton(newAttrs).run()
    },
    [editor],
  )

  const node = editor.state.doc.nodeAt(editor.state.selection.from)
  if (!node || node.type.name !== 'customButton') {
    return null
  }

  const attrs = node.attrs

  return (
    <div className="html-editor-custom-button-toolbar">
      <label className="html-editor-custom-button-toolbar__field">
        <span>Text</span>
        <input
          type="text"
          value={attrs.text || DEFAULT_BUTTON_TEXT}
          onChange={(e) => update({text: e.target.value})}
        />
      </label>

      <label className="html-editor-custom-button-toolbar__field">
        <span>Link</span>
        <input
          type="text"
          value={attrs.href || ''}
          onChange={(e) => update({href: e.target.value})}
          placeholder="https://..."
        />
      </label>

      <button
        type="button"
        className="html-editor-custom-button-toolbar__merge-code"
        onClick={() => update({href: '{{login_url}}'})}
      >
        Login
      </button>

      <label className="html-editor-custom-button-toolbar__field html-editor-custom-button-toolbar__field--narrow">
        <span>Size</span>
        <input
          type="number"
          min="1"
          value={attrs.fontSize || DEFAULT_FONT_SIZE}
          onChange={(e) =>
            update({
              fontSize: parseInt(e.target.value, 10) || DEFAULT_FONT_SIZE,
            })
          }
        />
      </label>

      <label className="html-editor-custom-button-toolbar__field html-editor-custom-button-toolbar__field--narrow">
        <span>Color</span>
        <input
          type="color"
          value={attrs.color || DEFAULT_BUTTON_COLOR}
          onChange={(e) => update({color: e.target.value})}
        />
      </label>

      <label className="html-editor-custom-button-toolbar__field html-editor-custom-button-toolbar__field--narrow">
        <span>BG</span>
        <input
          type="color"
          value={attrs.backgroundColor || DEFAULT_BUTTON_BACKGROUND_COLOR}
          onChange={(e) => update({backgroundColor: e.target.value})}
        />
      </label>

      <label className="html-editor-custom-button-toolbar__field html-editor-custom-button-toolbar__field--narrow">
        <span>Align</span>
        <select
          value={attrs.alignment || DEFAULT_BUTTON_ALIGNMENT}
          onChange={(e) => update({alignment: e.target.value})}
        >
          <option value="unset">Unset</option>
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </label>

      <label className="html-editor-custom-button-toolbar__field html-editor-custom-button-toolbar__field--narrow">
        <span>Width</span>
        <input
          type="text"
          value={attrs.width || 'auto'}
          onChange={(e) => update({width: e.target.value})}
          placeholder="auto"
        />
      </label>
    </div>
  )
}
